import { Col, Form, NavDropdown, Row } from "react-bootstrap";
import React, { useEffect, useState } from 'react'
import styles from './subscriptionWidget.module.scss'
import { PieChart } from '@mui/x-charts/PieChart';
import { useDrawingArea } from '@mui/x-charts/hooks';
import { styled } from '@mui/material/styles';
import { api } from "../../../../../../../Utils/API";
import { CUSTOMERS_SUBSCRIPTION_WIDGET, CUSTOMERS_SUBSCRIPTION_DOWNLOAD_WIDGET_REPORT } from "../../../../../../../Utils/GlobalConstants";
import Toast from "../../../../../../../GlobalComponents/Toast";
import Summary from "./LocalComponents/Summary";
import { useLocation } from "react-router-dom";
import { TOAST_ERROR_ICON_COLOR, WIDGETS_LABEL_FILL_COLOR, WIDGETS_PRIMARY_COLOR, WIDGETS_SECONDARY_COLOR } from "../../../../../../../Utils/ColorsConfiguration";
import { GenericDownloadEmptyToast } from "../../../../../../../Utils/StaticMessages/ToastMessages";

const SubscriptionWidget = ({ Logout, serviceData }) => {
  const date = new Date();                                                   // for js date time function
  const location = useLocation();                                            // use to access data from other page data

  const [pieChartData, setPieChartData] = useState([null])                   // for storing piechart data from api
  const [summaryPopup, setSummaryPopup] = useState(false);                   // for opening summary popup
  const [tabName, setTabName] = useState("Summary");                         // to store tab name
  const [total, setTotal] = useState(null);                                  // total custumers to be displayed in center of piechart label
  const [customerCode, setCustomerCode] = useState(location.state !== null ? location.state.customerCode : "");             // storing searching value in the search input box
  const [integrationCode, setIntegrationCode] = useState("microsoftsaas");    // used for filters services dropdown
  const [serviceId, setServiceId] = useState("");                             // used for filters services dropdown
  const [selectedItem3, setSelectedItem3] = useState('Microsoft CSP');        // State for service dropdwon

  // Use State for Toasts
  const [toastError, setToastError] = useState(false);                        // toast message displaying error message
  const [toastMessage, setToastMessage] = useState("");                       // toast message usestate

  const [customerName, setCustomerName] = useState(location.state?.customerName ? location.state?.customerName : "");
  const [isreadOnly, setIsreadOnly] = useState(localStorage.getItem("read_array") && localStorage.getItem("read_array").includes("Customers") ? true : false);

  // Header Authorization for General API's
  const config = {
    headers: {
      "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
    },
  };

  const StyledText = styled('text')(({ theme }) => ({
    fill: theme.palette.text.primary,
    textAnchor: 'middle',
    dominantBaseline: 'central',
    fontSize: 14,
  }));

  function PieCenterLabel({ children }) {
    const { width, height, left, top } = useDrawingArea();

    // Convert children to string
    const textContent = children.toString();
    const [labelWithCommas, numberWithCommas] = textContent.split(' ');

    // Remove commas from label
    const label = labelWithCommas.replace(/,/g, '');

    // Format number with commas
    const number = isNaN(parseInt(numberWithCommas.replace(/,/g, ''), 10)) ? '' : parseInt(numberWithCommas.replace(/,/g, ''), 10).toLocaleString();

    return (
      <StyledText x={left + width / 2} y={top + height / 2}>
        <tspan fill="grey" dy="-1.2em">{label}</tspan>
        <tspan className="text-strong text-large" fill={WIDGETS_LABEL_FILL_COLOR} x={left + width / 2} dy="1.2em">{number}</tspan>
      </StyledText>
    );
  }

  // Header Authorization for Download CSV API having response type as blob
  const configBlob = {
    headers: {
      "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
    },
    responseType: 'blob',
  };

  // Download File using Js blobs
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })
    const a = document.createElement('a')
    a.download = fileName
    if (fileType === "application/csv") {
      a.href = window.URL.createObjectURL(data)
    }
    else {
      a.href = window.URL.createObjectURL(blob)
    }
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  // Download CSV File 
  async function DownloadAction(url, name, fileType) {
    let configuration;
    if (fileType === "csv") {
      configuration = configBlob;
    }
    else {
      configuration = config;
    }
    await api.get(`${url}${customerCode}?serviceId=${serviceId}&integrationCode=${integrationCode}`, configuration)
      .then(resp => {
        if (resp.status === 204) {
          setToastMessage(GenericDownloadEmptyToast);
          setToastError(true);
          setTimeout(() => {
            setToastError(false);
          }, 2000);
        }
        else {
          downloadFile({
            data: (resp.data),
            fileName: name,
            fileType: `application/${fileType}`,
          });
        }
      })
      .catch(error => {
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        }
        else {
        }
      });
  };

  // Function to call subscriptions widget
  async function GetSubscriptions() {
    await api.get(`${CUSTOMERS_SUBSCRIPTION_WIDGET}${customerCode}?serviceId=${serviceId}&integrationCode=${integrationCode}`, config)
      .then(resp => {
        setPieChartData(resp.data);

        // Calculate the total sum
        let initialTotal = 0;
        resp.data.map((item) => {
          initialTotal += item.value;
        });
        setTotal(initialTotal);
      })
      .catch(error => {
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        }
        else {
        }
      });
  };

  // used for dropdown services
  function GetAllServices(selectedServiceName) {
    serviceData.map((service) => {
      if (service?.name === selectedServiceName) {
        setServiceId(service.id);
        setIntegrationCode(service.integrationCode);
        setSelectedItem3(selectedServiceName);
      }
    })
  }

  // Define a function to handle selecting a service from the dropdown
  const handleSelectService = (selectedServiceName) => {
    GetAllServices(selectedServiceName);
  };

  useEffect(() => {
    if (serviceId != "")
      GetSubscriptions();
  }, [integrationCode, serviceId]);

  useEffect(() => {
    GetAllServices(selectedItem3);
  }, []);

  return (
    <>
      <Row className={`${styles["widget-header"]} align-items-center pt-0`}>
        <Toast toastSetUseState={setToastError} toastCheckUseState={toastError} toastType="danger" toastIconColor={TOAST_ERROR_ICON_COLOR} toastMessage={toastMessage} />

        <Col md={6}>
          <h3 className="mb-0">Subscriptions</h3>
        </Col>
        <Col md={6} className="text-right">
          <span className="dashboard-arrow mx-1 cpointer" onClick={() => { setSummaryPopup(true); setTabName("Summary"); }}></span>
          <span className="dashboard-circle-dot mx-1 cpointer" onClick={() => { setSummaryPopup(true); setTabName("Details") }}></span>
          {!isreadOnly && <span className="dashboard-download mx-1 cpointer"
            onClick={() => { DownloadAction(CUSTOMERS_SUBSCRIPTION_DOWNLOAD_WIDGET_REPORT, `${String(date.getDate()).padStart(2, '0')}${String(date.getMonth() + 1).padStart(2, "0")}${date.getFullYear()}_${customerName}_subscriptions.csv`, "csv") }}>
          </span>}
        </Col>
        {
          summaryPopup &&
          <Summary setSummaryPopup={setSummaryPopup} summaryPopup={summaryPopup} tabName={tabName} setTabName={setTabName} selectedItem3={selectedItem3} setSelectedItem3={setSelectedItem3} integrationCode={integrationCode} setIntegrationCode={setIntegrationCode} serviceId={serviceId} setServiceId={setServiceId} customerCode={customerCode} Logout={Logout} serviceData={serviceData} />
        }
      </Row>
      <Row className={`pt-2 ${styles["widget-header"]} `}>
        <Col lg={6} md={8}></Col>
        <Col lg={6} md={4}>
          <Form.Group>
            <NavDropdown title={selectedItem3} id="cloud-service-dropdown-3" className={`servcies-dropdown ${styles['dropdown-disabled']}`} onSelect={handleSelectService}>
              <NavDropdown.Item eventKey="Microsoft CSP"
                className={selectedItem3 === "Microsoft CSP" ? "selected" : ""}
              >Microsoft CSP</NavDropdown.Item>
              <NavDropdown.Item eventKey="Google Workspace"
                className={selectedItem3 === "Google Workspace" ? "selected" : ""}
              >Google Workspace</NavDropdown.Item></NavDropdown>
          </Form.Group>
        </Col>
      </Row>
      <PieChart
        series={[{ data: pieChartData, innerRadius: 70, outerRadius: 84, }]}
        colors={[WIDGETS_PRIMARY_COLOR, WIDGETS_SECONDARY_COLOR]}
        slotProps={{
          legend: {
            direction: 'row',
            position: { vertical: 'bottom', horizontal: 'middle' },
            padding: 0,
            labelStyle: {
              fill: 'grey',
            },
          },
        }}
        margin={{ top: 0, bottom: 40, left: 80 }}
        height={210}
        width={400}
      >
        {pieChartData.length > 0 && <PieCenterLabel>Subscriptions {pieChartData && total}</PieCenterLabel>}
      </PieChart>
    </>
  )
}

export default SubscriptionWidget
